import { Invite, InviteAcceptedResponse } from '@/types'
import axios from 'axios'
import { apiUrl } from './environment'

export const createInvite = async (channelId: string): Promise<Invite> => {
  try {
    const response = await axios.get(apiUrl + `invite/create/${channelId}`, {
      withCredentials: true,
    })
    const data = response.data as Invite
    return data
  } catch (error: any) {
    console.error(error)
    return { link: '' }
  }
}

export const acceptInvite = async (
  inviteId: string
): Promise<InviteAcceptedResponse> => {
  try {
    const response = await axios.get(apiUrl + `invite/${inviteId}`, {
      withCredentials: true,
    })
    const data = response.data as InviteAcceptedResponse
    return data
  } catch (error: any) {
    console.error(error)
    return { status: '', message: '', invite: { link: '' } }
  }
}
